import React from 'react';
import { 
  MagnifyingGlassIcon, DocumentArrowDownIcon, UserPlusIcon 
} from '@heroicons/react/24/outline';
import { ViewMode } from './AttendeeFilters';

interface AttendeeActionsProps {
  viewMode: ViewMode;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onInviteClick?: () => void;
  onExportClick?: () => void;
  hasRegistrations?: boolean;
}

const AttendeeActions: React.FC<AttendeeActionsProps> = ({
  viewMode,
  searchQuery,
  onSearchChange,
  onInviteClick,
  onExportClick,
  hasRegistrations,
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div className="flex items-center gap-4 flex-1">
        <div className="relative flex-1 max-w-md">
          <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search attendees..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        
        {/* Invite button - only show if handler is provided (for backward compatibility) */}
        {viewMode !== 'activity' && onInviteClick && (
          <button
            onClick={onInviteClick}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
          >
            <UserPlusIcon className="h-5 w-5" />
            Invite
          </button>
        )}
      </div>
      
      {/* Export button - only show if handler is provided (for backward compatibility) */}
      {viewMode !== 'activity' && hasRegistrations && onExportClick && (
        <button
          onClick={onExportClick}
          className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center gap-2"
        >
          <DocumentArrowDownIcon className="h-5 w-5" />
          Export
        </button>
      )}
    </div>
  );
};

export default AttendeeActions;